import * as React from "react";
import Modal, { ModalProps } from "@ebsco-ui/modal";
import Button from "@ebsco-ui/button";
import { ButtonProps } from "@ebsco-ui/button";
import { createBemBlockBuilder } from "@ebsco-ui/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import cn from "classnames";

import "./dialog-notification.scss";

export interface DialogNotificationProps
  extends Omit<ModalProps, "children" | "onClose"> {
  acceptButtonStyleType?: ButtonProps["styleType"];
  acceptButtonText: string;
  acceptButtonIcon?: IconProp;
  children?: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
  onAccept: () => void;
  onReject: () => void;
  rejectButtonStyleType?: ButtonProps["styleType"];
  rejectButtonText: string;
}

const DialogNotification = React.forwardRef<
  HTMLDivElement,
  DialogNotificationProps
>(
  (
    {
      acceptButtonStyleType = "default",
      acceptButtonText,
      acceptButtonIcon,
      children,
      className,
      title = null,
      onAccept,
      onReject,
      rejectButtonStyleType = "text",
      rejectButtonText,
      ...rest
    },
    ref,
  ) => {
    const getBlocksWith = createBemBlockBuilder([
      "eb-dialog-notification",
      className,
    ]);

    return (
      <Modal {...rest} className={getBlocksWith()} onClose={onReject} ref={ref}>
        <div
          data-auto="dialog-notification-wrapper"
          className={getBlocksWith("__wrapper")}
        >
          <Modal.Header
            closeButtonProps={{ title: rejectButtonText, onClick: onReject }}
          >
            <h2 className={getBlocksWith("__title")}>{title}</h2>
          </Modal.Header>
          <Modal.Body>
            <section className={cn(className, getBlocksWith("__body-content"))}>
              <p
                data-auto="dialog-notification-body-description"
                className={cn(
                  getBlocksWith("__body-description"),
                  title && getBlocksWith("__body-description--secondary"),
                )}
              >
                {children}
              </p>
            </section>
          </Modal.Body>
        </div>
        <Modal.Footer>
          <Button
            className={getBlocksWith("__reject-button")}
            onClick={onReject}
            styleType={rejectButtonStyleType}
          >
            {rejectButtonText}
          </Button>
          <Button
            className={getBlocksWith("__accept-button")}
            onClick={onAccept}
            styleType={acceptButtonStyleType}
          >
            {acceptButtonIcon && (
              <FontAwesomeIcon
                className={getBlocksWith("__accept-button-icon")}
                icon={acceptButtonIcon}
              />
            )}
            {acceptButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  },
);

export default DialogNotification;
